module.exports = __webpack_public_path__ + "img/work-in-progress.1e290455.png";